module.exports = __webpack_public_path__ + "img/gBalm2.99b7f6fb.jpg";